// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-cell-usergroup[data-v-1c6dd35c]{display:flex;flex-wrap:wrap;padding:10px}.usergroup-entry[data-v-1c6dd35c]{padding-right:10px}`, "",{"version":3,"sources":["webpack://./src/shared/components/ncTable/partials/TableCellUsergroup.vue"],"names":[],"mappings":"AACA,uCACC,YAAA,CACA,cAAA,CACA,YAAA,CAGD,kCACC,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
